import {useEffect, useState} from 'react'
import {getRecentApps} from 'helpers/localStorage'
import {DEFAULT_RECENT_APP_IDS, resolveRecentAppEntity} from './recentAppsConfig'

// localStorage không tự bắn sự kiện trong CÙNG tab (chỉ bắn cho các tab khác) - RecentAppsTracker
// bắn event này ngay sau khi ghi nhận 1 lượt ghé, để 2 nơi hiển thị (sidebar/mobile) refresh ngay,
// không cần load lại trang.
export const RECENT_APPS_CHANGED_EVENT = 'kristo:recent-apps-changed'

const SHOW_LIMIT = 3

const buildDisplayIds = () => {
    const ids = getRecentApps().map(e => e.id)
    // Chưa đủ 3 app trong lịch sử thật (kể cả user mới, ids rỗng) - bù thêm fallback mặc định đã
    // chốt (Mass Times/Hymns/Lịch Phụng Vụ), bỏ qua nếu app đó đã có trong lịch sử.
    for (const id of DEFAULT_RECENT_APP_IDS) {
        if (ids.length >= SHOW_LIMIT) break
        if (!ids.includes(id)) ids.push(id)
    }
    return ids.slice(0, SHOW_LIMIT)
}

// 3 app "dùng gần nhất" (đã resolve icon/label/href thật từ functionRouteEntities) - dùng chung
// cho cả RecentAppsSiderShortcuts (desktop) và RecentAppsQuickAccessRow (mobile).
export const useRecentApps = () => {
    const [ids, setIds] = useState(buildDisplayIds)

    useEffect(() => {
        const onChange = () => setIds(buildDisplayIds())
        window.addEventListener(RECENT_APPS_CHANGED_EVENT, onChange)
        return () => window.removeEventListener(RECENT_APPS_CHANGED_EVENT, onChange)
    }, [])

    return ids.map(resolveRecentAppEntity).filter(Boolean)
}
